import * as React from 'react';
import Grid from '@mui/material/Grid';
import { SvgIconProps } from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import { Variant } from '@mui/material/styles/createTypography';

interface IProps {
  title: string;
  titleVariant?: Variant;
  subtitle?: string | undefined;
  Icon?: (props: SvgIconProps) => JSX.Element;
  isMasked?: boolean;
  px?: number;
  mb?: number;
  subtitleVariant?: Variant;
}

export default function PageHeader({ title, subtitle, titleVariant = 'h1', Icon, isMasked = false, px = 0, subtitleVariant = 'h4', mb = 3 }: IProps) {
  const className = isMasked ? 'fs-mask' : '';
  return (
    <Grid container sx={{ mb, pb: 2, px }}>
      <Grid item xs={12} xl={8}>
        <Typography variant={titleVariant} className={className}>
          {Icon ? <Icon fontSize='large' sx={{ marginRight: '10px' }} /> : null}
          {title}
        </Typography>
      </Grid>
      {!!subtitle && (
        <Grid item xs={12}>
          <Typography color='gray' variant={subtitleVariant} className={className}>
            {subtitle}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
}
